<template>
  <v-container fluid v-if="$apollo.loading">
    <v-row justify="center" align="center"
      ><v-progress-circular indeterminate color="primary"></v-progress-circular
    ></v-row>
  </v-container>
  <v-layout v-else>
    <v-flex xs12>
      <v-card
        :raised="!value"
        :flat="value != null"
        v-if="!$apollo.loading && purchaseInvoice"
        class="pt-0"
      >
        <v-card-title v-if="!value">
          <h1 class="headline">{{ purchaseInvoice.number }}</h1>
        </v-card-title>
        <v-row>
          <basic-components-list
            :list="boxes"
            :data="purchaseInvoice"
            :visibleItems="boxesSettings.visibleItems"
            :columns="boxesSettings.columns"
            @change="onBoxesSettingsChange"
          ></basic-components-list>
        </v-row>
        <v-row v-if="debug">
          <v-col>
            <code> pi: {{ purchaseInvoice }}, : {{ notes }} </code>
          </v-col>
        </v-row>
        <v-container fluid grid-list-xs pa-0 v-if="false">
          <v-layout row wrap fill-height>
            <v-flex xs12 sm4>
              <v-card color="box1-bg">
                <v-card-text class="white--text">
                  <p class="headline text-center">
                    <v-icon left dark large>mdi-home</v-icon>Supplier
                    <v-divider dark class="mt-1"></v-divider>
                  </p>
                  <p>
                    <small class="overline">Supplier Name:</small>
                    <v-spacer></v-spacer>
                    <span class="headline">{{
                      purchaseInvoice.supplier
                        ? purchaseInvoice.supplier.name
                        : ""
                    }}</span>
                  </p>
                  <p>
                    <small class="overline">Address:</small>
                    <v-spacer></v-spacer>
                    <span class="headline">{{
                      purchaseInvoice.supplier.address
                    }}</span>
                  </p>
                  <p>
                    <small class="overline">Telephone:</small>
                    <v-spacer></v-spacer>
                    <span class="headline">{{
                      purchaseInvoice.supplier.telephone
                    }}</span>
                  </p>
                  <p>
                    <small class="overline">Email:</small>
                    <v-spacer></v-spacer>
                    <span class="headline">{{
                      purchaseInvoice.supplier.email
                    }}</span>
                  </p>
                </v-card-text>
              </v-card>
            </v-flex>
            <v-flex xs12 sm4>
              <v-card color="cyan darken-2">
                <v-card-text class="box2-bg white--text">
                  <p class="headline text-center">
                    <v-icon left dark large>mdi-account-tie</v-icon>Agent
                    <v-divider dark class="mt-1"></v-divider>
                  </p>
                  <p>
                    <small class="overline">Agent Name:</small>
                    <v-spacer></v-spacer>
                    <span class="headline">{{
                      purchaseInvoice.agent ? purchaseInvoice.agent.name : ""
                    }}</span>
                  </p>
                  <p>
                    <small class="overline">Address:</small>
                    <v-spacer></v-spacer>
                    <span class="headline">{{
                      purchaseInvoice.agent ? purchaseInvoice.agent.address : ""
                    }}</span>
                  </p>
                  <p>
                    <small class="overline">Telephone:</small>
                    <v-spacer></v-spacer>
                    <span class="headline">{{
                      purchaseInvoice.agent
                        ? purchaseInvoice.agent.telephone
                        : ""
                    }}</span>
                  </p>
                  <p>
                    <small class="overline">Email:</small>
                    <v-spacer></v-spacer>
                    <span class="headline">{{
                      purchaseInvoice.agent ? purchaseInvoice.agent.email : ""
                    }}</span>
                  </p>
                </v-card-text>
              </v-card>
            </v-flex>
            <v-flex xs12 sm4>
              <v-card color="box3-bg">
                <v-card-text class="white--text">
                  <p class="headline text-center">
                    <v-icon left dark large>mdi-currency-usd</v-icon>Details
                    <v-divider dark class="mt-1"></v-divider>
                  </p>
                  <p>
                    <small class="overline">Invoice No:</small>
                    <v-spacer></v-spacer>
                    <span class="headline">{{ purchaseInvoice.number }}</span>
                  </p>
                  <p>
                    <small class="overline">Itinerary Ref:</small>
                    <v-spacer></v-spacer>
                    <span class="headline">{{
                      purchaseInvoice.itineraryReference
                    }}</span>
                  </p>
                  <p>
                    <small class="overline">Invoice Date:</small>
                    <v-spacer></v-spacer>
                    <span class="headline">{{
                      purchaseInvoice.createdAt
                    }}</span>
                  </p>
                  <p>
                    <small class="overline">Amount:</small>
                    <v-spacer></v-spacer>
                    <span class="headline">
                      {{ purchaseInvoice.amount }}
                      <small>{{ purchaseInvoice.currencyCode }}</small>
                    </span>
                  </p>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
        <v-card-text>
          <v-container grid-list-md fluid>
            <v-layout wrap>
              <v-flex>
                <v-text-field
                  v-model="supplierInvoiceNumber"
                  label="Supplier Inv Number"
                  :outlined="outlinedInputs"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm3>
                <date-picker
                  :gt-date-string="supplierInvoiceDate"
                  @onDateSelected="supplierInvoiceDate = $event"
                  customLabel="Supplier Inv Date"
                  :outlined="outlinedInputs"
                ></date-picker>
              </v-flex>
              <v-checkbox
                v-model="approved"
                @change="showApproveDialog = $event"
                label="Approved"
                class="ml-3"
                :disabled="$store.getters.hasAccessTo('finances:pi_view_only')"
              ></v-checkbox>
              <v-checkbox
                :disabled="!$store.getters.hasAccessTo('finances:unexport')"
                v-model="exported"
                label="Exported"
                class="ml-3"
              ></v-checkbox>
            </v-layout>
          </v-container>
          <v-container class="py-0" fluid>
            <v-row>
              <v-col class="py-0">
                <v-textarea
                  v-model="notes"
                  label="Notes"
                  :outlined="outlinedInputs"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-container>
          <v-layout>
            <v-flex xs12>
              <v-expansion-panels v-model="servicesPanel">
                <v-expansion-panel class="mt-4">
                  <v-expansion-panel-header>
                    <h5 class="title">Services Details</h5>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-data-table
                      :headers="itemsHeaders"
                      :items="items"
                      :loading="$apollo.loading"
                      v-bind="pagingOptions"
                      item-key="id"
                    >
                      <template v-slot:item.startDate="{ item }">{{
                        item.startDate | formatDate
                      }}</template>
                      <template v-slot:item.endDate="{ item }">{{
                        item.endDate | formatDate
                      }}</template>
                      <template v-slot:item.totalPrice="{ item }"
                        >{{ item.totalPrice | priceLabeler }}
                      </template>

                      <template v-slot:footer>
                        <v-layout justify-center>
                          <strong class="pr-3"
                            >Total:
                            {{
                              Number(
                                Number(totalPrice).toFixed(2)
                              ).toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })
                            }}
                            {{ purchaseInvoice.currencyCode }}</strong
                          >
                          <strong class="pr-3">
                            Paid:
                            {{
                              Number(
                                Number(purchaseInvoice.paid).toFixed(2)
                              ).toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })
                            }}
                            {{ purchaseInvoice.currencyCode }}
                          </strong>
                          <strong>
                            Balance:
                            {{
                              Number(
                                Number(purchaseInvoice.balance).toFixed(2)
                              ).toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })
                            }}
                            {{ purchaseInvoice.currencyCode }}
                          </strong>
                        </v-layout>
                      </template>
                    </v-data-table>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-flex>
          </v-layout>

          <v-expansion-panels v-if="approved" v-model="paymentPanel">
            <v-expansion-panel class="mt-4">
              <v-expansion-panel-header>
                <h5 class="title">Purchase Invoice Payments</h5>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <purchase-invoice-details-payment-list
                  :payments="purchaseInvoice.payments"
                  :supplier-name="purchaseInvoice.supplierName"
                  :itinerary-reference="purchaseInvoice.itineraryReference"
                  :balance="Number(purchaseInvoice.balance)"
                  :currency-code="
                    purchaseInvoice.supplier
                      ? purchaseInvoice.supplier.currencyCode
                      : ''
                  "
                  @onChange="doPaymentMutation"
                ></purchase-invoice-details-payment-list>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
          <v-expansion-panels v-model="adjustmentsPanel">
            <v-expansion-panel class="mt-4">
              <v-expansion-panel-header>
                <h5 class="title">Adjustments</h5>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <invoice-adjustments
                  v-model="adjustments"
                  @create="onAdjustmentCreate"
                  :create-disabled="
                    (purchaseInvoice && purchaseInvoice.exported) || approved
                  "
                />
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
          <v-expansion-panels v-model="attachmentsPanel">
            <v-expansion-panel class="mt-4">
              <v-expansion-panel-header>
                <h5 class="title">Attachments</h5>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <attachments
                  :owner-id="purchaseInvoice.id"
                  :owner-type="'PURCHASE_INVOICE'"
                ></attachments>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-card-text>
        <v-card-actions>
          <v-layout justify-center pb-3 v-if="!value">
            <v-btn
              color="primary"
              @click="savePurchaseInvoice"
              :disabled="$store.getters.hasAccessTo('finances:pi_view_only')"
              >Save</v-btn
            >
          </v-layout>
        </v-card-actions>
      </v-card>
      <back-to-list-btn
        v-if="false"
        route="/purchase-invoices"
      ></back-to-list-btn>
      <confirmation-dialog
        :show-dialog="showApproveDialog"
        :max-width="650"
        @onCloseDialog="onCancelApprove"
        @onConfirm="savePurchaseInvoice"
      >
        <template slot="message">
          If you approve this invoice you should restrict the changes that you
          make to this itinerary. Are you sure you want to generate a full
          invoice?
        </template>
      </confirmation-dialog>
    </v-flex>
  </v-layout>
</template>

<script>
import {
  PURCHASE_INVOICE_PAYMENT_CREATE_MUTATION,
  PURCHASE_INVOICE_RECORD_QUERY,
  PURCHASE_INVOICE_UPDATE_MUTATION,
  PURCHASE_INVOICE_PAYMENT_UPDATE_MUTATION,
  PURCHASE_INVOICE_PAYMENT_DELETE_MUTATION,
  CREATE_INVOICE_ADJUSTMENT,
} from "../../../../constants/graphql";
import ConfirmationDialog from "../../shared/ConfirmationDialog";
import PurchaseInvoicePaymentDetailsEditor from "../purchase-invoice-payments/PurchaseInvoicePaymentDetailsEditor";
import PurchaseInvoiceDetailsPaymentList from "../../finances/purchase-invoices/PurchaseInvoiceDetailsPaymentList";
import DatePicker from "../../shared/DatePicker";
import BackToListBtn from "../../shared/BackToListBtn";
import {
  sortByDate,
  pagingOptions,
  removeGQLTypename,
} from "../../../../helpers/index";
import BasicComponentsList from "../../shared/BasicComponentsList";
import InvoiceAdjustments from "./InvoiceAdjustments";
import boxes from "./pi-boxes-list.js";
import Attachments from "../../shared/attachments/Attachments.vue";
import EventBus from "../../../../store/event-bus";
export default {
  name: "PurchaseInvoiceDetails",

  props: {
    value: {
      type: Object,
      default: () => null,
    },
  },

  components: {
    ConfirmationDialog,
    DatePicker,
    PurchaseInvoicePaymentDetailsEditor,
    BackToListBtn,
    PurchaseInvoiceDetailsPaymentList,
    BasicComponentsList,
    InvoiceAdjustments,
    Attachments,
  },

  data() {
    return {
      debug: false,
      pagingOptions,
      id: this.value ? this.value.id : this.$route.params.id,
      purchaseInvoice: null,
      approved: false,
      exported: false,
      showApproveDialog: false,
      paymentPanel: 1,
      servicesPanel: 1,
      attachmentsPanel: null,
      adjustmentsPanel: null,
      supplierInvoiceNumber: "",
      notes: "",
      supplierInvoiceDate: "",
      historiesTableHeaders: [
        { text: "Start Date", value: "startDate", sort: sortByDate },
        { text: "End Date", value: "endDate", sort: sortByDate },
        { text: "Service", value: "serviceName" },
        { text: "Qty", value: "qty" },
        { text: "Adults", value: "adults" },
        { text: "Children", value: "children" },
        { text: "Infants", value: "infants" },
        { text: "Rate", value: "rateTypeCode" },
        { text: "Price", value: "totalPrice" },
      ],
      boxes: boxes,
      boxesSettings: this.$store.getters.localSettings(
        "purchaseInvoiceDetailsBoxesSettings",
        {
          visibleItems: ["Invoice No", "Amount", "Supplier"],
          coumns: 3,
        }
      ),
    };
  },

  computed: {
    hasMixedCurrency() {
      //return new Set(this.items.map((item) => item.currency)).size > 1;
      return (
        this.purchaseInvoice &&
        this.items.filter(
          (item) => item.currency != this.purchaseInvoice.currencyCode
        ).length > 0
      );
    },
    totalPrice() {
      return this.purchaseInvoice ? this.purchaseInvoice.amount : 0;
      // return this.items.reduce(
      //   (sum, item) => (sum += Number(item.totalInSupplierCurrency)),
      //   0
      // );
    },
    itemsHeaders() {
      if (this.purchaseInvoice && this.hasMixedCurrency) {
        return [
          ...this.historiesTableHeaders,
          { text: "Currency", value: "currency" },
          { text: "ROE", value: "roe" },
          {
            text: `${this.purchaseInvoice.currencyCode} Price`,
            value: "totalInSupplierCurrency",
          },
        ];
      } else {
        return [...this.historiesTableHeaders];
      }
    },
    items() {
      return this.purchaseInvoice && this.purchaseInvoice.itineraryItems
        ? this.purchaseInvoice.itineraryItems.edges
            .filter(
              (i) =>
                i.node.supplier &&
                i.node.supplier.id == this.purchaseInvoice.supplier.id &&
                i.node.isIncluded
            )
            .reduce((list, { node }) => {
              list.push({
                ...node,
                ...node.pax,
                currency: node.pricing.currencyBuy,
                roe: Number(node.pricing.currencyBuyExchangeRate).toFixed(2),
                totalPrice: Number(node.pricing.totalBuy).toFixed(2),
                totalInSupplierCurrency: Number(
                  node.totalCostInSupplierCurrency
                ).toFixed(2),
              });
              if (node.extras && node.extras.length > 0) {
                for (const extra of node.extras.filter((e) => e.isIncluded)) {
                  list.push({
                    ...extra,
                    serviceName: extra.name,
                    supplierName: node.supplierName,
                    totalPrice: Number(extra.totalBuy).toFixed(2),
                    currency: extra.currencyBuy,
                    roe: Number(extra.currencyBuyExchangeRate).toFixed(2),
                    totalInSupplierCurrency: Number(
                      extra.totalCostInSupplierCurrency
                    ).toFixed(2),
                  });
                }
              }
              return list;
            }, [])
        : [];
    },
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
    histories() {
      return this.purchaseInvoice
        ? this.purchaseInvoice.itinerary.histories.filter(
            (h) =>
              h.supplier && h.supplier.id === this.purchaseInvoice.supplier.id
          )
        : [];
    },
    adjustments() {
      return this.purchaseInvoice && this.purchaseInvoice.adjustments
        ? this.purchaseInvoice.adjustments.edges.map(removeGQLTypename)
        : [];
    },
  },

  watch: {
    value(newVal) {
      this.id = newVal.id;
    },
  },

  methods: {
    onBoxesSettingsChange(payload) {
      this.$store.dispatch("updateLocalSettings", {
        purchaseInvoiceDetailsBoxesSettings: { ...payload },
      });
    },
    savePurchaseInvoice() {
      this.$apollo
        .mutate({
          mutation: PURCHASE_INVOICE_UPDATE_MUTATION,
          variables: {
            id: this.id,
            approved: this.approved,
            exported: this.$store.getters.hasAccessTo("finances:unexport")
              ? this.exported
              : undefined,
            supplierInvoiceNumber: this.supplierInvoiceNumber,
            supplierInvoiceDate: this.supplierInvoiceDate,
            notes: this.notes,
          },
        })
        .then(this.saveGqlObjectHandler, this.saveGqlObjectErrorHandler);
    },
    saveGqlObjectHandler(result) {
      this.showApproveDialog = false;
      this.$store.dispatch("showAppSnackbar", {
        msg: "Purchase Invoice Updated.",
      });
      this.$emit("updated", result.data.updatePurchaseInvoice);
    },
    saveGqlObjectErrorHandler(err) {
      this.showApproveDialog = false;
      const errorMsg = err.graphQLErrors.map((e) => e.message).join(", ");
      this.$store.dispatch("showAppSnackbar", {
        msg: errorMsg,
        color: "error",
      });
    },
    doPaymentMutation(data) {
      const mutations = {
        create: PURCHASE_INVOICE_PAYMENT_CREATE_MUTATION,
        edit: PURCHASE_INVOICE_PAYMENT_UPDATE_MUTATION,
        delete: PURCHASE_INVOICE_PAYMENT_DELETE_MUTATION,
      };
      this.$apollo
        .mutate({
          mutation: mutations[data.action],
          variables: {
            purchaseInvoiceId: this.id,
            ...data.payload,
          },
          update: (store, { data: { invoicePaymentMutation } }) => {
            const storeData = store.readQuery({
              query: PURCHASE_INVOICE_RECORD_QUERY,
              variables: { id: this.id },
            });

            if (data.action === "create") {
              storeData.purchaseInvoice.payments.push(invoicePaymentMutation);
            } else if (data.action === "delete") {
              storeData.purchaseInvoice.payments =
                storeData.purchaseInvoice.payments.filter(
                  (payment) => payment.id !== invoicePaymentMutation.id
                );
            }

            let paid = storeData.purchaseInvoice.payments.reduce(
              (sum, payment) => {
                sum += payment.amount;
                return sum;
              },
              0
            );

            storeData.purchaseInvoice.paid = Number(paid).toFixed(2);
            storeData.purchaseInvoice.balance = Number(
              this.purchaseInvoice.amount - paid
            ).toFixed(2);
            store.writeQuery({
              query: PURCHASE_INVOICE_RECORD_QUERY,
              variables: { id: this.id },
              data: storeData,
            });
          },
        })
        .then((result) => {
          this.saveGqlPaymentHandler(data.action);
          EventBus.$emit("piPaymentSaved", result.data.invoicePaymentMutation);
        })
        .catch((err) => {
          this.saveGqlObjectErrorHandler(err);
        });
    },
    saveGqlPaymentHandler(context) {
      const actions = {
        create: "Created",
        edit: "Updated",
        delete: "Removed",
      };

      this.$store.dispatch("showAppSnackbar", {
        msg: "Purchase Invoice Payment " + actions[context],
      });
    },
    onCancelApprove() {
      this.showApproveDialog = false;
      this.approved = false;
    },
    onAdjustmentCreate(payload) {
      const input = { invoiceId: this.id, ...payload };
      this.$apollo
        .mutate({
          mutation: CREATE_INVOICE_ADJUSTMENT,
          variables: { input },
          refetchQueries: [
            {
              query: PURCHASE_INVOICE_RECORD_QUERY,
              variables: { id: this.id },
            },
          ],
        })
        .then(() => {
          this.$store.dispatch("showAppSnackbar", {
            msg: "Adjustment created.",
          });
        })
        .catch(this.saveGqlObjectErrorHandler);
    },
  },

  apollo: {
    purchaseInvoice: {
      query: PURCHASE_INVOICE_RECORD_QUERY,
      variables() {
        return {
          id: this.id,
        };
      },
      skip() {
        return !this.id;
      },
      result({ data }) {
        this.approved = data.purchaseInvoice.approved;
        this.supplierInvoiceNumber = data.purchaseInvoice.supplierInvoiceNumber;
        this.supplierInvoiceDate = data.purchaseInvoice.supplierInvoiceDate;
        this.paymentPanel = data.purchaseInvoice.payments.length > 0 ? 0 : 1;
        this.exported = data.purchaseInvoice.exported;
        this.notes = data.purchaseInvoice.notes;
      },
      fetchPolicy: "network-only",
    },
  },
};
</script>

<style scoped>
.box1-bg {
  background: linear-gradient(to right top, #37474f, #78909c);
  min-height: 370px;
}
.box2-bg {
  background: linear-gradient(to right top, #00695c, rgb(0, 196, 196));
  min-height: 370px;
}
.box3-bg {
  background: linear-gradient(to right top, #4a148c, #8e24aa);
  min-height: 370px;
}
</style>



// WEBPACK FOOTER //
// src/components/gt/finances/purchase-invoices/PurchaseInvoiceDetails.vue